import { Box, CircularProgress, Grid2, Typography } from '@mui/material';
import { useFormatting } from '../../utils/formatting';
import styled from '@emotion/styled';
import {
    useCompanyBalance,
    useTransactionStatistics
} from '../../services/paymentsQuery';
import { TextDisplayMDSemiBold, TextMedium } from '../../typography/Typography';
import { t } from 'i18next';
import { DashboardCard } from './common';

const BalanceList = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const TransactionStatistics = () => {
    const { data, isPending } = useTransactionStatistics();
    const { getBalanceLabelV2 } = useFormatting();
    console.log('TransactionStatistics data:', data);

    return (
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3.8 }}>
            <DashboardCard>
                {isPending && (
                    <Box mt={2} mr={10}>
                        <CircularProgress size={20} />
                    </Box>
                )}
                {!isPending && (
                    <>
                        <TextMedium textAlign={'left'}>
                            {t('amount_of_transactions_last_x_days', {
                                x: 30
                            })}
                        </TextMedium>
                        <TextDisplayMDSemiBold
                            textAlign={'left'}
                            color={
                                (data?.data?.transactionStatistics
                                    ?.transactionCount ?? 0) < 0
                                    ? '#D92D20'
                                    : undefined
                            }
                        >
                            {
                                data?.data?.transactionStatistics
                                    ?.transactionCount
                            }
                        </TextDisplayMDSemiBold>
                        <Typography
                            textAlign={'left'}
                            sx={{
                                fontFamily: 'Inter',
                                fontWeight: 700,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: 0
                            }}
                        >
                            {t('average_of_label')}{' '}
                            {getBalanceLabelV2(
                                data?.data?.transactionStatistics
                                    ?.averageAmount,
                                data?.data?.transactionStatistics?.currency ??
                                    'DKK',
                                { showNegativeStyle: true }
                            )}
                        </Typography>
                    </>
                )}
            </DashboardCard>
            <Box sx={{ clear: 'both' }}></Box>
        </Grid2>
    );
};
